import React, { Fragment, useEffect, useState } from "react";
import API from "@unisearch/helpers/api";
import styles from "./blog.module.scss";
import BlogBoxGrid from "@modules/study/blog/components/blog_grid_box";

export const EventBlog = ({ query }) => {
  const [loading, setLoading] = useState(false);
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let apiUrl = "";
        if (query) {
          apiUrl = `/public/blog-page/latest-post?query=${query}&limit=6`;
        } else {
          apiUrl = `/public/blog-page/latest-post?limit=6`;
        }
        const resp = await API.get(apiUrl);
        setLoading(false);
        setPosts(resp.data);
      } catch (error) {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <Fragment>
      {posts?.length > 0 ? (
        <section className={styles.section_blog_update}>
          <div className="container">
            <div className={styles.wrapper}>
              <div className={styles.title_container}>
                <h4 className={styles.blog_subtitle}>Blog Updates</h4>
                <h2 className={styles.blog_title}>
                  UniSearch Blog Posts and News Articles
                </h2>
              </div>
              <div className={styles.blog_wrapper}>
                {posts.map((post, i) => (
                  <BlogBoxGrid
                    key={i}
                    blogTitle={post?.blogTitle}
                    blogLink={`/blog/${post?.slug}`}
                    categoryTitle={post?.categoryName}
                    calegoryLink={`/blog/category/${post?.CategorySlug}`}
                    featureImage={post?.featureImageSrc}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>
      ) : (
        <></>
      )}
    </Fragment>
  );
};

export default EventBlog;
